// extracted by mini-css-extract-plugin
export default {"initLogin":"InitGoogleLoginButton_initLogin__5QZF8"};